<template>
  <div class="column">
    <label v-if="label !== ''">{{ t(label) }}</label>
    <textarea
      :maxLength="maxLength"
      @input="$emit('update', $event.target.value.trim())"
      :value="value"
      :required="required"
      :placeholder="t(placeholder)"
    ></textarea>

    <div class="text__count">{{ value.length }}/{{ maxLength }}</div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  emits: ['update'],
  props: {
    maxLength: { type: Number, default: 500 },
    type: { type: String, default: 'text' },
    value: { type: String, default: '' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
  },
  setup() {},
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.column {
  position: relative;

  textarea {
    max-width: calc(100% - 22px);
    min-width: calc(100% - 22px);
    padding: 7px 10px;
    height: 400px;
    max-height: 400px;
    resize: none;
    background-color: transparent;
  }

  .text__count {
    font-size: 0.8rem;
    position: absolute;
    bottom: 3px;
    right: 3px;
    color: var(--dark-4);
  }
}
</style>
